import { NgModule } from "@angular/core";
import { CoreModule } from "../core/core.module";
import { AssetMobileActionButtonWrapperComponent } from "./components/mobile-action-button-wrapper/asset-mobile-action-button-wrapper/asset-mobile-action-button-wrapper.component";
import { FiatMobileActionButtonWrapperComponent } from "./components/mobile-action-button-wrapper/fiat-mobile-action-button-wrapper/fiat-mobile-action-button-wrapper.component";
import { TradableActionButtonsComponent } from "./components/tradable-action-buttons/tradable-action-buttons.component";
import { FiatActionButtonsComponent } from "./components/fiat-action-buttons/fiat-action-buttons.component";
import { DetailPageActionButtonsComponent } from "./components/tradable-action-buttons/detail-page-action-buttons.component";
import { MatButtonModule } from "@angular/material/button";

const components = [
	AssetMobileActionButtonWrapperComponent,
	FiatMobileActionButtonWrapperComponent,
	TradableActionButtonsComponent,
	DetailPageActionButtonsComponent,
	FiatActionButtonsComponent
];

@NgModule({
	imports: [CoreModule, MatButtonModule],
	declarations: [...components],
	exports: [...components]
})
export class ActionButtonModule {}
